export default "__VITE_ASSET__CA_GkAQ0__"